module.exports = __webpack_public_path__ + "img/logo-familia-feliz.d8ec8071.svg";